<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col cols="12" md="6">
          <v-btn color="secondary" outlined class="mr-1" to="/admin/reports">
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to Reports
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="user-report-button-wrapper">
          <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="exportCsv('excel')"
            outlined
          >
          Email link to download Excel report
          </v-btn>
          <!-- <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="exportCsv('pdf')"
            outlined
          >
            Email Report <v-icon class="ml-1">mdi-file-pdf-box</v-icon>
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Courses"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applyCourseSearch"
              ></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col md="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
          <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories search-box" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
          </v-select> 
          </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="courses"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }"
            >
              <!--<template v-slot:item.completion_progress="{ item }">
                <v-progress-linear height="20" color="blue" :value="item.completion_progress"></v-progress-linear>
              </template>-->
              <template v-slot:item.total_enrolled_individual_users="{ item }">
                    <span v-if="item.total_enrolled_individual_users" class="clickable-count" @click.stop="openDialog($event,item.individual_users,'Individual Users')">{{ item.total_enrolled_individual_users }}</span>
                    <span v-else>{{ item.total_enrolled_individual_users }}</span>
              </template>
              <template v-slot:item.total_groups="{ item }">
                    <span v-if="item.total_groups" class="clickable-count" @click.stop="openDialog($event,item.groups,'Groups')">{{ item.total_groups }}</span>
                    <span v-else>{{ item.total_groups }}</span>
              </template>
              <template v-slot:item.total_channels="{ item }">
                    <span v-if="item.total_channels" class="clickable-count" @click.stop="openDialog($event,item.channels,'Playlists')">{{ item.total_channels }}</span>
                    <span v-else>{{ item.total_channels }}</span>
              </template>
              <template v-slot:item.total_users="{ item }">
                    <span v-if="item.total_users" class="clickable-count" @click.stop="openDialog($event,item.users,'Total Users')">{{ item.total_users }}</span>
                    <span v-else>{{ item.total_users }}</span>
              </template>
              <template v-slot:item.total_inprogress="{ item }">
                    <span v-if="item.total_inprogress" class="clickable-count" @click.stop="openDialog($event,item.inprogress_users,'In Progress Users')">{{ item.total_inprogress }}</span>
                    <span v-else>{{ item.total_inprogress }}</span>
              </template>
              <template v-slot:item.total_completed="{ item }">
                    <span v-if="item.total_completed" class="clickable-count" @click.stop="openDialog($event,item.completed_users,'Completed Users')">{{ item.total_completed }}</span>
                    <span v-else>{{ item.total_completed }}</span>
              </template>
              <template v-slot:item.total_not_started="{ item }">
                    <span v-if="item.total_not_started" class="clickable-count" @click.stop="openDialog($event,item.not_started_users,'Not Started Users')">{{ item.total_not_started }}</span>
                    <span v-else>{{ item.total_not_started }}</span>
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      :to="'/admin/reports/course/' + item.id"
                    >
                      <v-icon small>fa-search</v-icon>
                    </v-btn>
                  </template>
                  <span>Details</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Dialog -->
    <DialogComponent
        :isOpen="dialog"
        :dialogTitle="dialogTitle"
        :dialogData="dialogData"
        @close="closeDialog"
        />
  </layout-basic>
</template>
<script>
import courseAPI from '@/api/course.js';
import LayoutBasic from '@/layouts/Dashboard';
import DialogComponent from '@/components/Dialog';


export default {
  name: 'CourseReport',
  components: {
    LayoutBasic,
    DialogComponent
  },
  data() {
    return {
      headers: [
        { text: 'Course', value: 'name' },
        {
          text: 'Individual Users',
          value: 'total_enrolled_individual_users',
          sortable: false,
        },
        { text: 'Groups', value: 'total_groups', sortable: false },
        //{
        //  text: "Added Via Channel",
        //  value: "total_enrolled_via_channel_users",
        //  sortable: false
        //},
        {
          text: 'Playlists',
          value: 'total_channels',
          sortable: false,
        },
        { text: 'Total Users', value: 'total_users', sortable: false },
        { text: 'In Progress', value: 'total_inprogress', sortable: false },
        { text: 'Completed', value: 'total_completed', sortable: false },
        { text: 'Not Started', value: 'total_not_started', sortable: false },
        {
          text: 'Total Completion %',
          value: 'completion_progress',
          sortable: false,
        },
        { text: '', value: 'id', sortable: false, align: 'end' },
      ],
      courses: [],
      search: '',
      pagination: {},
      options: {},
      loading: false,
      searchParams: '',
      dialog: false,
      dialogTitle : '',
      dialogData: [],
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
     categories: [],
     selectedCategory: [],   
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.getAllCourseCategories();
    this.loadSearch();
  },
  methods: {
    applySearch() {
      this.options.page = 1;
      this.applyCourseSearch();
      this.saveSearch();
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      this.applyCourseSearch();
      this.saveSearch();
    },
    getCourses() {
      this.loading = true;
      // this.searchParams =
      //   this.search && this.search.length > 0
      //     ? '&search=name:' + this.search
      //     : '';
      courseAPI
        .getCoursesReport(
          this.params + '&include=thumbnail,test',
          this.searchParams
        )
        .then((resp) => {
          this.courses = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    exportCsv(type) {
      this.loading = true;
      courseAPI
        .exportCourse(
          '?page=1&orderBy=&sortedBy=asc&limit=' + this.pagination.total,
          '',
          '&type=' + type
        )
        .then((resp) => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    },
    saveSearch() {
      // Save search value to localStorage
      if(this.search && this.search.trim().length > 0){
        localStorage.setItem('course-report-search', this.search);
      }else{
        localStorage.removeItem('course-report-search');
      }
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('course-report-search');
      
      if (savedSearch && savedSearch !== 'null') {
        this.search = savedSearch;
      }
    },
    applyCourseSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.searchParams = this.search && this.search.length > 0
      ? '&search=' + this.search : '';
      
      if (this.selectedCategory.length) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
      }

      this.getCourses();


    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
    },
    filterCoursesByCategories(){
      this.applyCourseSearch();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearch()
    },
  },
};
</script>
